import { render, staticRenderFns } from "./markentry.vue?vue&type=template&id=73c70a60&"
import script from "./markentry.vue?vue&type=script&lang=js&"
export * from "./markentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports